import React from 'react';
import { withTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import BackendMobile from '../../Layouts/BackendMobile';
import MobileSearch from './helpers/MobileSearch';
import { Button, Checkbox } from '../../UI/Common';
import MobileActionMenu from './helpers/MobileActionMenu';
import { CustomInput } from 'reactstrap';
import MobileToggle from '../../UI/MobileToggle';

function DashboardMobileScreen({ alarmList, mobileConfig, t, ...props }) {
  const [filteredSensorIds, setFilteredSensorIds] = React.useState(null);
  const [selectMode, updateSelectMode] = React.useState(false);
  const [openActionMenu, setOpenActionMenu] = React.useState(false);
  const [alarms, setAlarms] = React.useState([]);
  const [currAlarm, selectAlarm] = React.useState([]);
  React.useEffect(() => {
    setAlarms(alarmList);
  }, [alarmList]);

  React.useEffect(() => {
    if (!selectMode) {
      selectAlarm([]);
    }
  }, [selectMode]);
  function getBgColor(alarmPriority) {
    let color = '';
    switch (alarmPriority) {
      //green
      case 0:
        color = '#75e5d0';
        break;
      case 1:
        //yellow
        color = '#fcf496';
        break;
      case 2:
        //red
        color = '#ffb0be';
        break;
      default:
        //blue
        color = '#6bcfed';
        break;
    }
    return color;
  }
  if (openActionMenu) {
    return (
      <MobileActionMenu
        alarm={currAlarm}
        onBack={() => setOpenActionMenu(false)}
      />
    );
  }
  function isChecked(al) {
    const result = currAlarm.filter(
      (currAl) => currAl.sensorId === al.sensorId,
    )[0];
    if (result) {
      return true;
    } else return false;
  }
  function onChangeCkbox(e, al) {
    if (e.target.checked) {
      selectAlarm([...currAlarm, al]);
    } else {
      selectAlarm((currAlarm) =>
        currAlarm.filter((currAl) => currAl.sensorId !== al.sensorId),
      );
    }
  }

  return (
    <BackendMobile>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          position: 'relative',
        }}
      >
        <div
          style={{ padding: '0px 10px' }}
          className="d-flex justify-content-between align-items-center"
        >
          {t('Last Updated')}: {props.lastUpdated}
          <Button
            style={{
              height: 20,
              padding: '0px 10px',
              fontSize: '.8rem',
              borderRadius: 10,
            }}
            classes="d-flex align-items-center"
            onClick={() => updateSelectMode(!selectMode)}
          >
            {selectMode ? 'Cancel' : 'Multi-select'}
          </Button>
        </div>
        {alarms
          .filter((alarm) => {
            if (filteredSensorIds === null) {
              return alarm;
            } else {
              return filteredSensorIds.includes(alarm.sensorId);
            }
          })
          .filter((alarm) => {
            if (props.isAlert) {
              return alarm.alarmPriority !== 0;
            } else return alarm;
          })
          .map((al) => {
            return (
              <div
                key={al.sensorId}
                className={`alarm-list-item-mobile`}
                style={{ backgroundColor: getBgColor(al.alarmPriority) }}
              >
                <div className="--left">
                  <span style={{ fontSize: 18, fontWeight: '500' }}>
                    {al.name}
                  </span>
                  <span style={{ fontSize: 16 }}>{al.location}</span>
                  <span style={{ fontSize: 16 }}>{al.groupName}</span>
                  {al.alarmPriority === 2 && (
                    <span style={{ fontSize: 12 }}>{al.timeDetected}</span>
                  )}
                  {al.alarmPriority !== 0 && (
                    <span style={{ fontSize: 12 }}>{al.alarmType}</span>
                  )}
                </div>
                <div className="--right">
                  <span
                    style={{ fontSize: 18, fontWeight: '500', lineHeight: 1.5 }}
                  >
                    {al.units}
                  </span>
                  <span
                    style={{ fontSize: 24, fontWeight: 'bold', lineHeight: 2 }}
                  >
                    {al.textValue}
                  </span>
                  <span className="m-dashboard-time-info">{al.timeInfo}</span>
                </div>

                <div className="--menu">
                  {selectMode ? (
                    <div>
                      <CustomInput
                        type="checkbox"
                        id={al.sensorId}
                        checked={isChecked(al)}
                        onChange={(e) => onChangeCkbox(e, al)}
                      />
                    </div>
                  ) : (
                    <div
                      // className="--menu"
                      onClick={() => {
                        selectAlarm([al]);
                        setOpenActionMenu(true);
                      }}
                    >
                      <i className="md-icon">more_vert</i>
                    </div>
                  )}
                  {al.ackEnabled ? (
                    <div className="ineligible-symbol">
                      <i className="md-icon">adjust</i>
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })}

        {selectMode ? (
          <Button
            style={{
              position: 'sticky',
              height: 30,
              width: '80%',
              bottom: 20,
              left: '10%',
            }}
            classes="d-flex align-items-center justify-content-center"
            disabled={!currAlarm.length || currAlarm.length > 5}
            onClick={() => setOpenActionMenu(true)}
          >
            Actions
          </Button>
        ) : null}
        <MobileSearch
          alarmList={alarmList}
          onSearch={(result) => setFilteredSensorIds(result)}
        />
        <div style={{ padding: 20 }}>
          <NavLink to="/configure/mobile-configurations/presets">
            <Button classes="button-block">{t('Configuration Preset')}</Button>
          </NavLink>
          <Button onClick={props.onLogout} classes="button-block mb-0">
            {t('Logout')}
          </Button>
        </div>
        <div>
          <MobileToggle
            isMobile={props.isMobile}
            setIsMobile={props.setIsMobile}
          />
        </div>
      </div>
    </BackendMobile>
  );
}

export default withTranslation('app')(DashboardMobileScreen);

const Item = (props) => {
  return <div {...props} />;
};
